export const EventEmitter = {
  emit: (eventName: string, payload?: unknown) => {
    window.dispatchEvent(new CustomEvent(eventName, { detail: payload }));
  },
  listen: (eventName: string, callback: (e: Event) => void) => {
    window.addEventListener(eventName, callback);
  },
  removeListener: (eventName: string, callback: (e: Event) => void) => {
    window.removeEventListener(eventName, callback);
  },
};
